import { render, staticRenderFns } from "./ScrollSelectorNew.vue?vue&type=template&id=3d428d1b&scoped=true&"
import script from "./ScrollSelectorNew.vue?vue&type=script&lang=js&"
export * from "./ScrollSelectorNew.vue?vue&type=script&lang=js&"
import style0 from "./ScrollSelectorNew.vue?vue&type=style&index=0&id=3d428d1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d428d1b",
  null
  
)

export default component.exports